import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Response, Headers } from '@angular/http';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { SessaoService } from './sessao.service';
import { Contrato } from '../modelo/contrato';
import { EnderecoContrato } from '../modelo/enderecoContrato';

@Injectable()
export class ExtratoContratoService {

    constructor(
        private restClient: RestClientService,
        private sessaoService: SessaoService
        ) {

    }

    listarContrato = () : Observable<EnderecoContrato> => {
        let resourcePath = Config.EXTRATOCONTRATO_PATH + "/listarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarContrato = (nuContrato: number) : Observable<Contrato> => {
        let resourcePath = Config.EXTRATOCONTRATO_PATH + "/recuperarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + nuContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/extratocontrato.service.ts